module.exports = __webpack_public_path__ + "officialStatic/img/case4.d921da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case4.png
// module id = UFxB
// module chunks = 0